import { IProperty } from '../../../../types-library/src'

interface Props {
  children?: React.ReactNode
  className?: string
  property: IProperty
  onPropertyClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const Layout = ({
  children,
  className = '',
  onPropertyClick,
  onMouseEnter,
  onMouseLeave,
}: Props): JSX.Element => {
  return (
    <div
      data-testid="property-card"
      onClick={() => {
        onPropertyClick?.()
      }}
      className={`relative w-full h-[378px] bg-slate-100 border border-[#EBEDF0] rounded-2xl overflow-hidden
      ${onPropertyClick ? 'cursor-pointer' : ''}
       ${className}
      `}
      onMouseEnter={() => {
        onMouseEnter?.()
      }}
      onMouseLeave={() => {
        onMouseLeave?.()
      }}
    >
      {children}
    </div>
  )
}

export default Layout
